import React from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer
} from "recharts";

const EducationReports = ({ config }) => {

  /* ---------------- SAMPLE DATA ---------------- */

  const hourlyEntryData = [
    { time: "08:00", value: 12 },
    { time: "09:00", value: 35 },
    { time: "10:00", value: 22 },
    { time: "11:00", value: 18 },
    { time: "12:00", value: 9 }
  ];

  const hourlyExitData = [
    { time: "15:00", value: 5 },
    { time: "16:00", value: 12 },
    { time: "17:00", value: 28 },
    { time: "18:00", value: 19 }
  ];

  const attendanceTrendData = [
    { time: "Mon", value: 95 },
    { time: "Tue", value: 92 },
    { time: "Wed", value: 97 },
    { time: "Thu", value: 94 },
    { time: "Fri", value: 90 }
  ];

  const weeklyTrendData = [
    { time: "Week 1", value: 450 },
    { time: "Week 2", value: 470 },
    { time: "Week 3", value: 430 },
    { time: "Week 4", value: 480 }
  ];

  /* ---------------- NO DATA COMPONENT ---------------- */

  const NoData = () => (
    <div className="flex items-center justify-center h-[260px] text-gray-400">
      No data available
    </div>
  );

  /* ---------------- GRAPH COMPONENT ---------------- */

  const TrendGraph = ({ title, data }) => {

    const hasData = data && data.length > 0;

    return (

      <div className="bg-white p-6 rounded-xl shadow border">

        <h3 className="text-lg font-semibold mb-4">
          {title}
        </h3>

        {!hasData ? (
          <NoData />
        ) : (

          <ResponsiveContainer width="100%" height={260}>

            <AreaChart data={data}>

              <CartesianGrid strokeDasharray="3 3" />

              <XAxis dataKey="time" />

              <YAxis />

              <Tooltip />

              <Area
                type="monotone"
                dataKey="value"
                stroke="#6366f1"
                fill="#c7d2fe"
              />

            </AreaChart>

          </ResponsiveContainer>

        )}

      </div>

    );

  };

  /* ---------------- WIDGET REGISTRY ---------------- */

  const WIDGETS = {

    /* Staff Attendance Reports */

    "Hourly Entry Trend": () =>
      <TrendGraph title="Hourly Staff Entry Trend" data={hourlyEntryData} />,

    "Hourly Exit Trend": () =>
      <TrendGraph title="Hourly Staff Exit Trend" data={hourlyExitData} />,

    "Staff Attendance Trend": () =>
      <TrendGraph title="Daily Attendance Trend" data={attendanceTrendData} />,

    "Weekly Attendance Trend": () =>
      <TrendGraph title="Weekly Attendance Trend" data={weeklyTrendData} />,

    /* Extra Useful Education Reports */

    "Late Arrival Trend": () =>
      <TrendGraph title="Late Arrival Trend" data={[]} />,

    "Early Exit Trend": () =>
      <TrendGraph title="Early Exit Trend" data={[]} />,

    "Staff Presence Distribution": () =>
      <TrendGraph title="Staff Presence Distribution" data={[]} />,

    "Peak Entry Hour": () =>
      <TrendGraph title="Peak Entry Hour Analysis" data={[]} />

  };

  /* ---------------- RENDER ---------------- */

  return (

    <div>

      {config?.rows?.map((row, idx) => (

        <div
          key={idx}
          className={`grid grid-cols-${row.cards.length} gap-6 mb-6`}
        >

          {row.cards.map((card, i) => {

            const Widget = WIDGETS[card.name];

            if (!Widget) return null;

            return (
              <div key={i}>
                <Widget />
              </div>
            );

          })}

        </div>

      ))}

    </div>

  );

};

export default EducationReports;